import React, { useEffect, useState } from "react";
import { LuClipboardX, LuClock, LuClipboardCheck, LuInbox } from "react-icons/lu";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ReceiveOrder = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  // Fetch data from API
  const fetchOrders = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_received"
      );

      if (response.data && response.data.status === "true") {
        setOrders(response.data.data);
      } else {
        toast.error("Failed to fetch orders");
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error("Something went wrong while fetching data");
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);


  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_received",
        { id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        setOrders((prevUser) =>
          prevUser.filter((user) => user.id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/inventory-received-orders");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete category.");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Received Orders</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Inventory</a>
                </li>
                <li className="breadcrumb-item active">Received Orders</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}

        {/* Summary Cards */}
        <div className="row">
          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h4 className="card-title mb-2">Pending Review</h4>
                  <p className="text-muted fw-medium fs-22 mb-0">210</p>
                </div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
                  <LuClipboardX className="fs-32 text-primary avatar-title" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h4 className="card-title mb-2">Pending Payment</h4>
                  <p className="text-muted fw-medium fs-22 mb-0">608</p>
                </div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
                  <LuClock className="fs-32 text-primary avatar-title" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h4 className="card-title mb-2">Delivered</h4>
                  <p className="text-muted fw-medium fs-22 mb-0">200</p>
                </div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
                  <LuClipboardCheck className="fs-32 text-primary avatar-title" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h4 className="card-title mb-2">In Progress</h4>
                  <p className="text-muted fw-medium fs-22 mb-0">656</p>
                </div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
                  <LuInbox className="fs-32 text-primary avatar-title" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Orders Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <h4 className="card-title">All Received Orders</h4>
                <div className="dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle btn btn-sm btn-outline-light rounded"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    This Month
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a href="#!" className="dropdown-item">
                      Download
                    </a>
                    <a href="#!" className="dropdown-item">
                      Export
                    </a>
                    <a href="#!" className="dropdown-item">
                      Import
                    </a>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table align-middle mb-0 table-hover table-centered">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th>Order ID</th>
                      <th>Customer</th>
                      <th>Items</th>
                      <th>Amount</th>
                      <th>Payment Status</th>
                      <th>Received Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.length > 0 ? (
                      orders.map((order) => (
                        <tr key={order.id}>
                          <td>{order.order_id}</td>
                          <td>{order.customer_name}</td>
                          <td>{order.items}</td>
                          <td>${order.amount}</td>
                          <td>
                            <span
                              className={`badge ${
                                order.payment_status === "Paid"
                                  ? "bg-success text-white"
                                  : "bg-secondary text-white"
                              } py-1 px-2`}
                            >
                              {order.payment_status}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                order.received_status === "Delivered"
                                  ? "bg-success-subtle text-success"
                                  : "bg-warning-subtle text-warning"
                              } py-1 px-2`}
                            >
                              {order.received_status || "Pending"}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                                <span
                                  onClick={() => deleteUser(order.id)}
                                  className="btn btn-soft-danger btn-sm"
                                >
                                  <i class="fa-solid fa-trash align-middle fs-18"></i>
                                </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-3 text-muted">
                          No orders found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Previous
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="javascript:void(0);">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        2
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        3
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href className="fw-bold footer-text" target="_blank" rel="noreferrer">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ReceiveOrder;
